export default __webpack_public_path__ + "static/media/title-pro.a21e0ba5.png";